import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/*',
      name: 'Hello_all',
      component: Hello
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js